import { mapState, mapActions } from 'vuex';

export default {
  name: 'JobProxyTest',
  props: {
    jobId: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({ dialog: false }),
  computed: {
    ...mapState('jobs', {
      jobProxyTestResultCode: ({ jobProxyTestResult: v }) => JSON.stringify(v, null, '\t'),
    }),
  },
  methods: {
    ...mapActions('jobs', {
      async runJobProxyTest(dispatch) {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await dispatch('runJobProxyTest', { id: this.jobId });
          this.dialog = true;
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      },
    }),
  },
};
